import assert from 'assert';

import {RowSubmissionRange} from 'notebook/structured-tables/action-functions/makeSubmitRowActionFunction';
import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';

import {StructuredTableDiff, TableSubmissionDiffs} from './getStructuredTableCellDiffOnSubmission';

/**
 * Returns the subset of tableSubmissionUpdates corresponding to the given selection.
 */
export function sliceTableSubmissionUpdates(
  tableSubmissionUpdates: Array<StructuredTableDiff>,
  selection: RowSubmissionRange,
  structuredTable: UnknownStructuredTable
): Array<StructuredTableDiff> {
  assert(tableSubmissionUpdates.length <= 1, 'Selected submission rows should not span multiple tables');
  if (tableSubmissionUpdates.length > 0) {
    const tableDiff = tableSubmissionUpdates[0];
    const rowIds = structuredTable.rows.slice(selection.start, selection.end).map((row) => row.rowId);
    return [
      {
        ...tableDiff,
        rowDiffs: tableDiff.rowDiffs.filter((rowDiff) => rowIds.includes(rowDiff.rowId)),
      },
    ];
  } else {
    return [];
  }
}

/**
 * Returns the subset of tableSubmissionDiffs corresponding to the given selection.
 */
export default function sliceTableSubmissionDiffs(
  tableSubmissionDiffs: TableSubmissionDiffs,
  selection: RowSubmissionRange,
  structuredTable: UnknownStructuredTable
): TableSubmissionDiffs {
  return {
    tableSubmissionUpdates: sliceTableSubmissionUpdates(
      tableSubmissionDiffs.tableSubmissionUpdates,
      selection,
      structuredTable
    ),
    expectedTableSubmissionAuditDiffs: sliceTableSubmissionUpdates(
      tableSubmissionDiffs.expectedTableSubmissionAuditDiffs,
      selection,
      structuredTable
    ),
  };
}
